import { useEffect } from "react";
import { useChainStore } from "../store/chainStore";
import { useLayoutStore } from "../store/layoutStore";
import { computeElkLayout } from "./elkLayout";

export function useChainLayout(onLayoutReset?: () => void): void {
  const systems = useChainStore((s) => s.systems);
  const layoutKey = useChainStore((s) => s.chainId);
  const resetLayout = useLayoutStore((s) => s.resetLayout);
  const prune = useLayoutStore((s) => s.prune);

  useEffect(() => {
    const { systems: cur, connections: curConn } = useChainStore.getState();
    if (cur.length === 0) return;
    const existing = useLayoutStore.getState().positions;
    if (cur.every((s) => existing[s.id] != null)) {
      onLayoutReset?.();
      return;
    }
    let cancelled = false;
    computeElkLayout(cur, curConn).then((positions) => {
      if (cancelled) return;
      resetLayout(positions);
      onLayoutReset?.();
    });
    return () => {
      cancelled = true;
    };
  }, [layoutKey, resetLayout, onLayoutReset]);

  useEffect(() => {
    const systemIds = new Set(systems.map((s) => s.id));
    prune(systemIds);
  }, [systems, prune]);
}
